import { Check, HeartHandshake } from "lucide-react";
import { CARE_PLANS, CARE_LOOKUP } from "../content/site";
import { Reveal, SectionHeading } from "./Reveal";
import { PayButton } from "./PayButton";

export const CarePlans = () => (
  <section id="care-plans" data-testid="care-plans-section" className="relative py-24 lg:py-32 bg-[#F0F4FF] overflow-hidden">
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading align="center"
          overline="Monthly care plans"
          title="We keep your website running. You don't lift a finger."
          sub="Optional ongoing management for any website — updates, backups, security and support handled every month. Cancel or change plans anytime."
        />
      </Reveal>
      <div className="mt-16 grid md:grid-cols-3 gap-5 max-w-5xl mx-auto items-stretch">
        {CARE_PLANS.map((p, i) => (
          <Reveal key={p.id} delay={0.08 * i} className="h-full">
            <article
              data-testid={`care-plan-${p.id}`}
              className={`relative h-full rounded-3xl p-8 flex flex-col bg-white transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-2 ${
                p.highlight
                  ? "border border-slate-200 border-t-2 !border-t-[#0055FF] shadow-[0_24px_64px_rgba(0,85,255,0.12)]"
                  : "border border-slate-200 soft-shadow hover:shadow-[0_16px_48px_rgba(2,6,23,0.08)]"
              }`}
            >
              {p.highlight && (
                <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-[#0055FF] text-white text-[11px] font-semibold tracking-wide uppercase px-4 py-1.5 rounded-full glow-blue whitespace-nowrap">
                  Recommended
                </span>
              )}
              <div className="flex items-center gap-3 mb-5">
                <span className={`w-10 h-10 rounded-xl flex items-center justify-center ${p.highlight ? "bg-[#F0F4FF]" : "bg-slate-50 border border-slate-200"}`}>
                  <HeartHandshake className={`w-5 h-5 ${p.highlight ? "text-[#0055FF]" : "text-cyan-600"}`} />
                </span>
                <h3 className="font-display text-xl font-semibold text-slate-900 tracking-tight">{p.name}</h3>
              </div>
              <p className="font-mono2 text-4xl font-semibold text-slate-900">
                {p.price}<span className="text-base text-slate-400 font-normal">/month</span>
              </p>
              <ul className="mt-7 space-y-3 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-slate-600">
                    <Check className="w-4 h-4 mt-0.5 shrink-0 text-cyan-600" /> {f}
                  </li>
                ))}
              </ul>
              <PayButton lookupKey={CARE_LOOKUP[p.id]} label={`Subscribe — ${p.price}/mo`} testid={`care-plan-cta-${p.id}`}
                className={`mt-8 w-full ${
                  p.highlight ? "bg-[#0055FF] hover:bg-[#0044CC] text-white glow-blue" : "border border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white"
                }`} />
              <a href="#contact" data-testid={`care-plan-chat-${p.id}`}
                className="mt-3 text-center text-xs text-slate-400 hover:text-slate-600 transition-colors duration-200">
                Questions first? Talk to us
              </a>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
